const KEY = "pd-floor-resume";
export interface FloorResume { roomId: string; token: string; name: string; lastTick: number }

/** Tab-local credential only: never persist the seed, map or account token. */
export function readFloorResume(): FloorResume | null {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    if (!value || typeof value !== "object") return null;
    const r = value as Record<string, unknown>;
    if (typeof r.roomId !== "string" || typeof r.token !== "string" || typeof r.name !== "string" ||
        !Number.isSafeInteger(r.lastTick) || (r.lastTick as number) < -1) return null;
    return { roomId: r.roomId, token: r.token, name: r.name, lastTick: r.lastTick as number };
  } catch { return null; }
}

export function writeFloorResume(resume: FloorResume | null): void {
  try {
    if (resume) sessionStorage.setItem(KEY, JSON.stringify(resume));
    else sessionStorage.removeItem(KEY);
  } catch { /* Storage may be disabled; in-memory reconnect still works. */ }
}
